import { css } from 'styled-components';

export const stretchColumn = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;

  > *:not([data-stretch]) {
    flex-shrink: 0;
  }
`;
